import api from "./client";

// Google OAuth / Gmail
export const getGoogleAuthStatus = () => api.get("/auth/google/status");
export const getGoogleAuthorizeUrl = (loginHint) =>
  api.get("/auth/google/authorize", { params: loginHint ? { login_hint: loginHint } : {} });
export const getMyMailbox = () => api.get("/auth/google/my-mailbox");
export const authorizeMyMailbox = () => api.post("/auth/google/my-mailbox/authorize");
export const getGoogleAccounts = () => api.get("/auth/google/accounts");
export const logoutGoogle = (email) =>
  email ? api.post("/auth/google/logout", null, { params: { email } }) : api.post("/auth/google/logout");
export const sendTestEmail = (data) => api.post("/integrations/test-email", data);

// Xero Accounting
export const getXeroAuthStatus = () => api.get("/auth/xero/status");
export const getXeroAuthorizeUrl = () => api.get("/auth/xero/authorize");
export const disconnectXero = () => api.post("/auth/xero/disconnect");
export const selectXeroTenant = (tenantId) => api.post("/auth/xero/select-tenant", { tenant_id: tenantId });

// Integration Status
export const getIntegrationsStatus = () => api.get("/integrations/status");

// Google Drive
export const getDriveFolderContents = (folderId) => api.get(`/drive/folder/${folderId}`);
export const uploadPropertyPhotos = (data) => api.post("/drive/upload-photos", data, { timeout: 240000 });

// Vapi Voice
export const getVoiceStatus = () => api.get("/integrations/voice/status");
export const makeVoiceCall = (data) => api.post("/integrations/test-voice-call", data);
export const getVoiceCallStatus = (callId) => api.get(`/integrations/voice/call/${callId}`);

// Browser Voice Calling (Twilio Voice SDK)
export const getVoiceToken = () => api.post("/voice/token");
export const logVoiceCall = (data) => api.post("/voice/log-call", null, { params: data });
export const lookupCaller = (phone) => api.get("/voice/lookup-caller", { params: { phone } });
export const checkVoiceConfig = () => api.get("/voice/check-config");
// Twilio Voice kill-switch + credential probe status. Called on mount
// before initDevice() so the call button stays hidden when the backend
// credentials are invalid instead of showing a 20101 error on click.
export const getTwilioVoiceStatus = () => api.get("/voice/twilio-status");

// Frontend error reporting (used by Twilio Voice call button to surface
// browser-side failures to the backend logs)
export const reportCallError = (data) => api.post("/diagnostics/call-error", data);

// Meetings (Fireflies integration)
export const getMeetings = (params) => api.get("/meetings", { params });
export const getMeeting = (communicationId) => api.get(`/meetings/${communicationId}`);
export const syncMeetings = (limit = 20) => api.post("/meetings/sync", null, { params: { limit } });
export const linkMeeting = (communicationId, data) => api.patch(`/meetings/${communicationId}/link`, null, { params: data });
export const unlinkMeeting = (communicationId) => api.patch(`/meetings/${communicationId}/unlink`);
